import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from '@cotyorg/ccx-molecules/Accordion';
import {
  Tabs,
  TabsHeader,
  TabTitle,
  TabsBody,
  TabContent,
} from '@cotyorg/ccx-molecules/Tabs';
import SectionHeader from '../../../../atoms/SectionHeader';

const mapIndex = R.addIndex(R.map);

export const FaqSection = ({ sectionHeadings, tabs }) => (
  <div className="faq-section">
    <SectionHeader>
      <Heading extraClass="section__title" level={2}>
        {R.path(['faq', 'heading'])(sectionHeadings)}
      </Heading>

      <Paragraph>{R.path(['faq', 'introduction'])(sectionHeadings)}</Paragraph>
    </SectionHeader>

    <Tabs>
      <TabsHeader>
        {mapIndex(
          (tab, index) => (
            <TabTitle key={index}>{R.prop('heading', tab)}</TabTitle>
          ),
          tabs
        )}
      </TabsHeader>

      <TabsBody>
        {mapIndex(
          (tab, index) => (
            <TabContent key={index}>
              <Accordion>
                {mapIndex(
                  (accordion, accordionIndex) => (
                    <AccordionItem key={accordionIndex}>
                      <AccordionItemTitle
                        buttonExtraClass="accordion__item-button"
                        minusIconSrc="/ccx-files/assets/chevron-up.svg"
                        plusIconSrc="/ccx-files/assets/chevron-down.svg"
                      >
                        {R.prop('heading', accordion)}
                      </AccordionItemTitle>

                      <AccordionItemBody>
                        <Paragraph>
                          {R.prop('introduction', accordion)}
                        </Paragraph>
                      </AccordionItemBody>
                    </AccordionItem>
                  ),
                  R.prop('accordion', tab)
                )}
              </Accordion>
            </TabContent>
          ),
          tabs
        )}
      </TabsBody>
    </Tabs>
  </div>
);

FaqSection.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
  tabs: PropTypes.instanceOf(PropTypes.array),
};
